import axiosInstance from "$lib/js/axios.js";

export const getArticles = async () => {
	try {
		const response = await axiosInstance.get("/articles/get/")
		return response.data.articles;
	} catch (error) {
		console.error(error)
		return []
	}
};

export const getArticle = async (articleID) => {
	try {
		const response = await axiosInstance.get(`/articles/get/${articleID}/`)
		if (response.data.status) { return response.data.article }
		return false
	} catch (error) {
		console.error(error)
		return []
	}
};

export const getCategories = async () => {
	try {
		const response = await axiosInstance.get("/categories/get/")
		return response.data.categories
	} catch (error) {
		console.error(error)
		return []
	}
};

export const getCategory = async (categoryID) => {
	try {
		const response = await axiosInstance.get(`/category/get/${categoryID}/`)
		return response.data.category
	} catch (error) {
		console.error(error)
		return []
	}
};

export const getProducts = async () => {
	try {
		const response = await axiosInstance.get(`/shop/products/get/`)
		return response.data.products
	} catch (error) {
		console.error(error)
		return []
	}
};

export const getProduct = async (productID) => {
	try {
		const response = await axiosInstance.get(`/shop/products/get/${productID}/`)
		return response.data.product
	} catch (error) {
		console.error(error)
		return []
	}
};